import { Button, styled, TableHead } from "@mui/material";

const InitializeAccountButton = styled(Button)(() => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    borderRadius: '100rem',
    height: '2.5em',
    width: '8em',
    "&.Mui-disabled": {
        backgroundColor: "#D9D9D9",
        color: "A6A6A6"
    }
}));

const DeleteAccountButton = styled(Button)(() => ({
    backgroundColor: '#FF8C45',
    color: '#FFFFFF',
    borderRadius: '100rem',
    height: '2.5em',
    width: '8em',
    "&.Mui-disabled": {
        backgroundColor: "#D9D9D9",
        color: "A6A6A6"
    }
}));

const AddAccountButton = styled(Button)(() => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    borderRadius: '100rem',
    height: '2.5em',
    width: '10em',
    position: 'absolute',
    right: 'calc(100% - 97%)'
}));

const ListHeader = styled(TableHead)(() => ({
    "& .MuiTableCell-head": {
        backgroundColor: '#F7F2DE'
    }
}));

export { InitializeAccountButton, DeleteAccountButton, AddAccountButton, ListHeader }
